import apiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const putFeatureFlag = (token, id, Active, FeatureName, FeatureDescription, PricePerMonth) => {
    return fetch(`${apiUrl}feature_flags/${id}`, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            Active,
            FeatureName,
            FeatureDescription,
            PricePerMonth
        })
    });
}

export default putFeatureFlag